import { isVideoType } from '../videoPlayerTypes';
const isIdParts = (s) => [3, 4].includes(s.length) && isVideoType(s[2]);
// Split ExternalId string into its constituent parts. Throws exceptions if the
// id is invalid.
//
// Valid ids should be in the form:
//     "<player>:<media id>:<'video'|'playlist'>:<autoplay>"
const splitId = (externalId) => {
    if (externalId == null)
        throw new Error('tmlExternalId required');
    const parts = externalId.split(':');
    if (!isIdParts(parts))
        throw new TypeError('invalid JW Player tmlExternalId');
    return parts;
};
// Decode the JW Player tml-external-id. Throws exceptions if the id is invalid.
// Return an object with the named properties.
export const decodeTmlExternalId = (jwplayerConfig, externalId) => {
    if (jwplayerConfig == null)
        throw new Error('jwplayerConfig required');
    const [player, mediaId, type, hasAutoplay] = splitId(externalId);
    const autoPlay = hasAutoplay?.toLowerCase() === 'autoplay';
    return {
        player,
        mediaId,
        type,
        autoPlay,
    };
};
// Validate a ContentVideo or throw an exception.
const validateContentVideo = (contentVideo) => {
    if (contentVideo == null)
        throw new Error('contentVideo required');
    if (!['jwplayer', 'jwplayerPlaylist'].includes(contentVideo.videoPlatformCode)) {
        throw new Error('not a JW Player ContentVideo: ' + contentVideo.videoPlatformCode);
    }
};
// Gather the JW Player video parameters from a site and a contentVideo.
export const getVideoParameters = (jwplayerConfig, contentVideo) => {
    if (jwplayerConfig == null)
        throw new Error('jwplayerConfig required');
    validateContentVideo(contentVideo);
    return {
        player: jwplayerConfig.playerId,
        mediaId: contentVideo.videoPlatformId,
        type: contentVideo.videoPlatformCode === 'jwplayer' ? 'video' : 'playlist',
        // default. Potentially overridden by site.config.video.autoPlay
        autoPlay: false,
    };
};
// Returns a JWPlayer video URL given VideoParameters.
const parametersToUrl = (parts) => `https://content.jwplatform.com/players/${parts.mediaId}-${parts.player}.html`;
// Returns a JWPlayer manifest URL.
export const getManifestUrl = (parts) => `https://content.jwplatform.com/manifests/${parts.mediaId}.m3u8`;
// Return the JW Player video URL given the 5 parts tml-external-id. Throws
// exceptions if parameters are invalid.
export const tmlExternalIdToUrl = (jwplayerConfig, tmlExternalId) => parametersToUrl(decodeTmlExternalId(jwplayerConfig, tmlExternalId));
// Return the JW Player video URL from the jwplayerConfig and a contentVideo.
// Throws exceptions if parameters are invalid.
export const contentVideoToUrl = (videoConfig, contentVideo) => {
    const parts = getVideoParameters(videoConfig.jwplayer, contentVideo);
    // Site config for video should dictate the auto play behavior
    // for any ContentVideo object.
    parts.autoPlay = videoConfig.autoPlay ?? false;
    return parametersToUrl(parts);
};
//# sourceMappingURL=index.js.map